import { gql } from "@apollo/client";
import {WarehouseType} from "./WarehouseType";

export const DSP_FIELDS = gql`
    fragment DspFields on DspType {
      id
      name
      fullName
      dspCode
      contactName
      contactPhone
      contactEmail
      operationEmail
      status
      paymentTermDays
      exitDelayDays
      createdAt
      updatedAt
      openSettlementConfig
      settlementTrackingPoint
      billingCycleConfiguration
      settlementMode
      billType
      timeZoneIana
      billUnitType
      warehouses {
        id
        name
      }
    }
`;

export interface DspType {
    id?: string;
    name: string;
    fullName: string;
    dspCode: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    operationEmail?: string;
    status: number;
    paymentTermDays?: number;
    exitDelayDays?: number;
    createdAt?: string;
    updatedAt?: string;
    warehouses: WarehouseType[];
    warehouseIds: number[];
    openSettlementConfig?: boolean;
    settlementTrackingPoint?: string;
    billingCycleConfiguration?: number;
    settlementMode?: number;
    billType?: number[];
    timeZoneIana?: string;
    billUnitType?: number;
}